<template>
  <q-dialog
    ref="dialog"
    @hide="onDialogHide"
  >
    <q-card
      flat
      bordered
      class="q-dialog-plugin"
      style="max-width: 450px; width: 90vw; white-space: pre-wrap"
    >
      <q-toolbar
        dense
        color="primary"
      >
        <q-avatar>
          <q-icon
            name="mdi-arrow-collapse"
            color="green"
            size="md"
            class="q-pa-none"
          />
        </q-avatar>

        <q-toolbar-title>
          <span class="text-weight-bold">Iniciar Atendimento</span>
        </q-toolbar-title>

        <q-btn
          flat
          round
          dense
          icon="mdi-close"
          data-testid="template-iniciar-fechar"
          v-close-popup
        />
      </q-toolbar>

      <q-separator inset />

      <q-card-section class="q-pt-sm">
        <div class="column">
          <FieldSelect
            data-testid="template-iniciar-fila"
            label="Fila de Atendimento"
            :state="queue.state"
            :configs="queue.configs"
            type="text"
            is-required
            v-model="queue.value"
          />

          <div
            class="col-auto q-pt-sm"
            v-html="message"
          />
        </div>
      </q-card-section>

      <q-separator />

      <q-card-actions align="around">
        <q-btn
          flat
          no-caps
          padding="5px 12px"
          color="primary"
          data-testid="template-iniciar-cancelar"
          @click="onCancelClick"
        >
          Cancelar Envio
        </q-btn>

        <q-btn
          no-caps
          unelevated
          padding="5px 12px"
          color="green-8"
          data-testid="template-iniciar-enviar"
          @click="handleSendTemplate"
        >
          {{ schedule? "Agendar template": "Enviar template" }}
        </q-btn>
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import FieldSelect from '@/components/fields/FieldSelect'

export default {
  components: {
    FieldSelect
  },

  props: {
    template: {},
    schedule: { default: false },
    apiData: { default: null }
  },

  data () {
    const vm = this
    const message = toStr(vm.template.message)
    const queue = toParamField({ name: 'queueId', value: 'Fila de Atendimento' })
    const queues = Array.isArray(vm.template.queues) ? vm.template.queues.map(({ queueId, queueName }) => ({ id: queueId, label: queueName })) : []
    queue.configs.values = queues

    const apiQueue = vm.apiData?.queueId
    const preSelectedQueue = queues.length === 1 ? queues[0].id : null
    const isValidApiQueue = apiQueue && queues.some(q => q.id === apiQueue)

    queue.value = isValidApiQueue ? apiQueue : preSelectedQueue

    return { message, queue }
  },

  created () {
    if (this.apiData && this.isFormComplete()) {
      const queueId = this.queue.value
      this.$nextTick(() => {
        this.$emit('ok', { queueId })
        this.$emit('hide')
      })
    }
  },

  methods: {
    show () {
      this.$refs.dialog.show()
    },

    hide () {
      this.$refs.dialog.hide()
    },

    onDialogHide () {
      this.$emit('hide')
    },

    handleSendTemplate () {
      const vm = this
      const queueId = vm.queue.value
      vm.$emit('ok', { queueId })
      vm.hide()
    },

    onCancelClick () {
      this.hide()
    },

    isFormComplete () {
      if (!this.queue.value) return false

      if (this.apiData?.queueId) {
        return this.queue.value === this.apiData.queueId
      }

      return true
    }
  }
}

const toStr = (val) => String(val || '').trim()

const toParamField = ({ name, value }) => ({
  id: name,
  label: value,
  value: null,

  state: {
    dirty: false,
    error: null
  },

  configs: {
    fieldRequired: true,
    fieldWidth: 'col-auto'
  }
})
</script>
